// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j1-0";
export var fileCarousel = "_j1-2";
export var removeFileButton = "_j1-1";